/* eslint-disable no-param-reassign */
// Utils
import { addObjectAdditionsAndDeletionChanges } from './addObjectAdditionsAndDeletionChanges';
import { addObjectPropertiesChanges } from './addObjectPropertiesChanges';
import { hasUncommitted } from '../hasUncommited';
import { EMPTY_OBJECT } from 'ezyvet-fe-helpers/dist/constant';
/**
 * Takes a committable values object, builds a list of changes since the last commit and returns them.
 *
 * @template T extends object
 * @param {T} values
 *
 * @return {ChangeList}
 */
export var detectChanges = function (values) {
    if (!hasUncommitted(values)) {
        // No changes if values are committed
        return EMPTY_OBJECT;
    }
    var changes = {};
    // First we get all the object additions and deletions
    addObjectAdditionsAndDeletionChanges(values, changes);
    // Once we are aware of the object additions and deletions we get the values
    addObjectPropertiesChanges(values, changes);
    return changes;
};
//# sourceMappingURL=detectChanges.js.map